import { helpers, maxLength, required } from '@vuelidate/validators';

export const NOT_EMPTY_BARCODE = { required: helpers.withMessage('empty_barcode', required) };
export const BARCODE_HAS_MANY_CHAR = { maxLength: helpers.withMessage('ШК не может быть больше чем 13 символов', maxLength(13)) };

export default null;
